import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { apiSlice } from '@src/services/api/apiSlice';
import { layoutSlice } from './layout/layoutSlice';
import { modalSlice } from './modal/modalSlice';
import { userSlice } from './user/userSlice';
import { useDispatch } from 'react-redux';

const persistConfig = {
    key: 'root',
    storage,
    version: 1,
    whitelist: ['user', 'layout'],
};
const rootReducer = combineReducers({
    layout: layoutSlice.reducer,
    modal: modalSlice.reducer,
    user: userSlice.reducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).concat(apiSlice.middleware),
    devTools: true,
});

export const persistor = persistStore(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
